const theme = require('./theme');
export { theme };
